import CreateQuotePopup from "./CreateQuotePopup";

export default CreateQuotePopup;



// WEBPACK FOOTER //
// ./src/components/CreateQuotePopup/index.js